cv.RootView = Marionette.LayoutView.extend({
  el: "body",

  behaviors: [
    {
      behaviorClass: cv.NotificationBehavior,
    },
    {
      behaviorClass: cv.PublicBehavior,
    },
    {
      behaviorClass: cv.ProjectBehavior,
    },
    {
      behaviorClass: cv.TeamBehavior,
    },
    {
      behaviorClass: cv.ShareBehavior,
    },
  ],

  regions: {
    content: "#content",
  },

  childEvents: {
    // This callback will be called whenever a child is rendered or emits a `render` event
    show: function (view) {
      this.post_show(view);
    },
    render: function () {},
  },

  initialize: function (options) {
    this.options = _.extend(
      {
        bypass_all_links: false,
      },
      options
    );

    this.post_show = _.debounce(
      _.bind(function (view) {
        console.groupEnd();
        console.group("Showing view...");

        // Old stuff
        // Remove all labels
        this.$(".notif.error, .help-label").remove();

        // Remove notifications
        vent.trigger("notif:clear");

        // Scroll to top
        this.$("#content-view").scrollTop(0);

        console.log("Firing post show...");
      }, this),
      500,
      false
    );

    // Bind the main regions
    if (this.$("#top").length > 0) {
      this.addRegions({ top: "#top", top_buttons: "#top-buttons" });
      this.showChildView("top", new cv.TopView());
    }
    if (this.$("#modal").length > 0) {
      this.addRegions({ modal: "#modal" });
      this.showChildView("modal", new cv.ModalView());
    }
    if (this.$("#tray").length > 0) {
      this.addRegions({ tray: "#tray" });
      this.showChildView("tray", new cv.TrayView());
    }

    // Tray toggle
    this.listenTo(
      vent,
      "tray:after_show",
      function () {
        this.$el.css({ overflow: "hidden", position: "fixed", width: "100%", height: "100%" });
      },
      this
    );
    this.listenTo(
      vent,
      "tray:before_hide",
      function () {
        this.$el.css({ overflow: "auto", position: "relative", width: "auto", height: "auto" });
      },
      this
    );

    // Preview event
    this.listenTo(
      vent,
      "app:enter_preview",
      function () {
        this.$el.addClass("in-preview");
        new cv.PreviewView();
      },
      this
    );
    this.listenTo(
      vent,
      "app:exit_preview",
      function () {
        this.$el.removeClass("in-preview");
      },
      this
    );

    // Manipulate the view to remove scrollbars from body
    this.listenTo(
      vent,
      "modal:after_show",
      function () {
        this.$el.css({ overflow: "hidden" });
      },
      this
    );
    this.listenTo(
      vent,
      "modal:after_hide",
      function () {
        this.$el.css({ overflow: "auto" });
      },
      this
    );

    // Bind the bypass link handler
    if (this.options.bypass_all_links == false) {
      this.$("#content, #top").on("click", "a:not([data-bypass])", function (e) {
        var href = $(this).attr("href");
        var protocol = this.protocol + "//";

        // Check for prevent default and hashed urls
        if (!e.isDefaultPrevented() && !_.isUndefined(href) && href != "#") {
          // Navigate if we are an internal url
          if (href.slice(protocol.length) !== protocol) {
            e.preventDefault();

            Backbone.history.navigate(href, true);
          }
        }
      });
    }

    // Special handler for the tray
    this.$("#tray").on("click", "a:not([data-bypass])", function (e) {
      var href = $(this).attr("href");
      var protocol = this.protocol + "//";

      // Check for prevent default and hashed urls
      if (!e.isDefaultPrevented() && !_.isUndefined(href) && href != "#") {
        // Navigate if we are an internal url
        if (href.slice(protocol.length) !== protocol) {
          e.preventDefault();

          // Check if this is a team based route
          var fragment = Backbone.history.getFragment();
          if (fragment.indexOf("team/") == 0) {
            cv.teamAdminRouter.navigate(href, { trigger: true });
          } else {
            cv.adminRouter.navigate(href, { trigger: true });
          }
        }
      }
    });

    // Remove the bootloader
    this.$(".boot-loader").remove();

    console.log("RootView initialized.");
  },
});

// Before start
cv.on("before:start", function (options) {
  var view_options = {};

  // Set up the API path and preloaded things
  cv.api_path = options.PRELOADED.api_path;
  cv.new_api_path = options.PRELOADED.new_api_path;
  cv.unsaved_views = {};
  cv.PRELOADED = options.PRELOADED;

  switch (options.PRELOADED.group) {
    case "pay":
      // Set up the router
      cv.router = new cv.PayRouter();

      // Set up the initial models
      if (!_.isUndefined(options.PRELOADED.campaign)) {
        cv.campaign = new cv.Campaign(
          { data: options.PRELOADED.campaign },
          { parse: true, synced: true }
        );
        console.log(cv.campaign.attributes);
      }

      // Set up API key
      cv.setupPrefilter("api_key", options.PRELOADED.public_api_key);

      break;
    case "auth":
      // Set up the router
      cv.router = new cv.AuthRouter();

      // Set up the initial models
      if (!_.isUndefined(options.PRELOADED.campaign)) {
        cv.campaign = new cv.Campaign(
          { data: options.PRELOADED.campaign },
          { parse: true, synced: true }
        );
        console.log(cv.campaign.attributes);
      }
      if (!_.isUndefined(options.PRELOADED.user)) {
        cv.user = new cv.User({ data: options.PRELOADED.user }, { parse: true, synced: true });
        console.log(cv.user.attributes);
      }
      if (!_.isUndefined(options.PRELOADED.project)) {
        cv.project = new cv.Project(
          { data: options.PRELOADED.project },
          { parse: true, synced: true }
        );
        console.log(cv.project.attributes);

        // Load the admin router
        cv.adminRouter = new cv.AdminRouter(cv.project.get("stub") + "/admin");
      }

      // Set up some ajax prefilter stuff
      cv.setupPrefilter("api_key", options.PRELOADED.api_key);
      cv.setupPrefilter("campaign_id", cv.campaign.get("id"));

      break;
    case "public":
      // Set up the router
      cv.router = new cv.PublicRouter();

      // Set up the initial models
      if (!_.isUndefined(options.PRELOADED.campaign)) {
        cv.campaign = new cv.Campaign(
          { data: options.PRELOADED.campaign },
          { parse: true, synced: true }
        );
        console.log("campaign attributes", cv.campaign.attributes);
      }
      if (!_.isUndefined(options.PRELOADED.user)) {
        cv.user = new cv.User({ data: options.PRELOADED.user }, { parse: true, synced: true });
        console.log("user attributes", cv.user.attributes);
      }
      if (!_.isUndefined(options.PRELOADED.project)) {
        cv.project = new cv.Project(
          { data: options.PRELOADED.project },
          { parse: true, synced: true }
        );
        console.log("project attributes", cv.project.attributes);

        // Load the admin router
        cv.adminRouter = new cv.AdminRouter(cv.project.get("stub") + "/admin");

        // Load the team admin router
        if (!_.isUndefined(cv.project.get("team.id"))) {
          cv.teamAdminRouter = new cv.TeamAdminRouter(
            "team/" + cv.project.get("team.stub") + "/admin",
            {
              team_model: new cv.Team(
                { data: options.PRELOADED.team },
                { parse: true, synced: true }
              ),
            }
          );
        }
      }

      // Set up API key
      cv.setupPrefilter("api_key", options.PRELOADED.api_key);
      cv.setupPrefilter("campaign_id", cv.campaign.get("id"));

      view_options.bypass_all_links = true;

      break;
  }

  // Sentry configuration
  if (cv.environment != "development") {
    Raven.config("https://78f90194ed1a416ca179301e1976c4d6@sentry.io/123855", {
      environment: cv.environment,
    }).install();
  }

  // Set up the root view
  cv.rootView = new cv.RootView(view_options);
});

cv.on("start", function (options) {
  if (Backbone.history) {
    Backbone.history.start({ pushState: true });
  }
});
